module.exports = __webpack_public_path__ + "img/paytmM.79953def.png";